import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { V2BottomSheetRef } from '../../../../v2-components/helpers/v2-bottom-sheet-ref';
import { UserService } from '../../../../services/user.service';
import { RemoteLoggerService } from '../../../../services/remote-logger.service';
import { FullScreenLoadingService } from '../../../../services/full-screen-loading.service';
import { BottomSheetService } from '../../../../v2-components/services/bottom-sheet.service';
import { PhoneVerification2Sheet } from '../order-phone-verification-2-sheet/phone-verification-2.sheet';
import { AnalyticsService } from '../../../../services/analytics.service';
import { LocationStore } from '../../../../stores/location.store';

@Component({
  selector: 'phone-verification-1',
  templateUrl: 'phone-verification-1.sheet.html',
  styleUrls: ['phone-verification-1.sheet.scss']
})
export class PhoneVerification1Sheet implements OnInit {
  // Validity (including required + per-country format) is supplied by the
  // <v2-phone-input> control bound to this FormControl; the control's value is
  // canonical E.164.
  readonly phoneInputControl = new FormControl('');

  isSubmitting = false;

  constructor(
    public bottomSheetRef: V2BottomSheetRef<V2BottomSheetRef>,
    private userService: UserService,
    private logger: RemoteLoggerService,
    private fullScreenLoadingService: FullScreenLoadingService,
    private bottomSheetService: BottomSheetService,
    private analyticsProvider: AnalyticsService,
    public locationStore: LocationStore
  ) {}

  ngOnInit(): void {
    this.analyticsProvider.log('Phone verification sheet 1 shown');
  }

  async onSubmit(): Promise<void> {
    this.phoneInputControl.markAsTouched();
    if (!this.phoneInputControl.valid) return;

    this.isSubmitting = true;
    this.fullScreenLoadingService.showFullScreenLoader();
    this.phoneInputControl.setErrors(null);
    try {
      await this.userService.submitPhoneNumber(this.phoneInputControl.value);
      this.bottomSheetRef.close(
        this.bottomSheetService.showBottomSheet(PhoneVerification2Sheet)
      );
    } catch (e) {
      this.logger.capture(e);
      this.phoneInputControl.setErrors({ invalid: true });
    } finally {
      this.isSubmitting = false;
      this.fullScreenLoadingService.hideFullScreenLoader();
    }
  }
}
